import { render, staticRenderFns } from "./loadingView.vue?vue&type=template&id=350bd950"
import script from "./loadingView.vue?vue&type=script&lang=js"
export * from "./loadingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports